import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "PlaybackPause.svg",
  "use": "PlaybackPause.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"PlaybackPause.svg\"><path d=\"M25.01,50.0208h-6a3,3,0,0,1-3-3v-30a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v30A3,3,0,0,1,25.01,50.0208Zm14,0a3,3,0,0,1-3-3v-30a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v30a3,3,0,0,1-3,3Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol